// src/components/Pricing.js
import React, { useContext } from "react";
import { Container, Stack, Heading, Text } from "@chakra-ui/react";
import CtaButtonEmail from "./ctaButtonEmail.tsx";
import CustomBadge from "./badge.tsx";
import { LanguageContext } from "../components/LanguageProvider"; // Import kontekstu językowego
import { messages } from "../intl/config"; // Import dostępnych tłumaczeń

function Pricing() {
  const { locale = "en" } = useContext(LanguageContext); // Odczyt aktualnego języka z kontekstu
  const translations = messages[locale] || {}; // Ładowanie tłumaczeń zgodnie z aktualnym językiem

  return (
    <Container maxW={"4xl"} id="pricing">
      <Stack
        align={"center"}
        spacing={{ base: 8, md: 10 }}
        py={{ base: 20, md: 28 }}
        paddingBottom={{ base: 24, md: 36 }}
        direction={{ base: "column", md: "row" }}
      >
        <Stack flex={1} spacing={{ base: 5, md: 10 }} alignItems={"center"}>
          <Stack alignItems={"center"}>
            <CustomBadge text={translations["pricing.badge"] || "Default Badge"} />
            <Heading
              lineHeight={1.1}
              fontWeight={600}
              fontSize={{ base: "2xl", sm: "3xl", lg: "5xl" }}
              align={"center"}
            >
              <Text as={"span"} color="gray.700">
                {translations["pricing.heading"] || "Default Heading"}
              </Text>
            </Heading>
          </Stack>
          <Text color={"gray.700"} align={"center"} fontSize={{ base: "md", sm: "md", lg: "xl" }}>
            {translations["pricing.description"] || "Default Description"}
          </Text>
          <CtaButtonEmail text={translations["pricing.ctaEmail"] || "Default Email"} />
        </Stack>
      </Stack>
    </Container>
  );
}

export default Pricing;
